import React, {Component} from 'react'

import Registry from '../../../registry/index';

const NICK_EXISTS_MESSAGE = 'User with such nick already exists';

class GuestForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            formData: {
                nick: btoa(Math.random()).substr(6, 6)
            },
            error: '',
        };

        this._onError = this._onError.bind(this);
        this._onSuccess = this._onSuccess.bind(this);
    }

    sendData() {
        let { nick } = this.state.formData;
        let{ anonymousSession } = this.props;

        //if (!nick.match(/^[A-Za-z][A-Za-z0-9_]{2,}$/)) {
        //    this.setState({error: 'invalid-characters'});

        //    return false;
        //}

        if(anonymousSession.remaining <= 0) {
            this.setState({error: 'time-expired'});
            return false;
        }
        this.setState({error: ''});

        let chatInterface = Registry.get('chatInterface');
        if(chatInterface.isLoggedIn()) chatInterface.logout();
        chatInterface.setGuestNick(nick);

        let thisform = this;
        window.setTimeout(function(){
            chatInterface.login(
                thisform._onSuccess,
                thisform._onError
            )
        }, 300);
    }

    _onSuccess(_response) {
        this.setState({
            formData: {
                nick: ''
            },
            error: ''
        });

        this.props.onLoginSuccess();
        this.props.close();
    }

    _onError(code, message) {
        let error = 'generic';

        if (message === NICK_EXISTS_MESSAGE) error = 'user-exists';

        this.setState({error});
    }

    render() {
        let lang = Registry.get('locale');
        let{ anonymousSession } = this.props;

        let { 
            error,
            formData
        } = this.state;
        let disabledEnter = !formData.nick ? 'disabled' : '';

        return (
            <div className="guest-form content">
                {anonymousSession.remaining > 0 ?
                    <button
                        className="popup-button primary"
                        disabled={disabledEnter}
                        onClick={() => this.sendData()}
                    >{lang.enter_as_anonymous}</button>
                    :
                    <p className="msg">{lang.you_have_reached_visitors_limit}</p>
                }

                <p className="error" dangerouslySetInnerHTML={{__html: error}} />
            </div>
        )
    }
}

export default GuestForm;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/AnonymousLoginPopup/GuestForm.js